import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PortalReportingService {
    private readonly portalReportingUrl: string;

    constructor(
        private http: HttpClient,
        private config: AppConfig) {

        this.portalReportingUrl = this.config.backendPortalUri + 'Reporting.WebAPI/';
    }

    /**
     * Adds an action using the portal reporting API
     * @param action Action user made
     * @returns void
     */
    public addAction(action: string, data?: string): Observable<void> {
        const url = this.portalReportingUrl + 'ApplicationUsages/Add';

        const payload: any = {
            ApplicationId: this.config.productId,
            Action: action,
            Data: data
        }

        return this.http.post<void>(url, payload);
    }
}